$(document).ready(function () {
    /* Select active menu */
    var adress = window.location.pathname;
    first = adress.split('/');
    first = first[1];
    if (adress == '/') {
        $(".test").first().addClass('activeMenu');
    } else {
        $("#mainMenu > li").each(function (index) {
            if ($(this).html().indexOf(adress) > 0) {
                $("#mainMenu > .activeMenu").removeClass('activeMenu');
                $(this).addClass('activeMenu');
                if ($(this).hasClass('dropdown-submenu')) {
                    console.log(this);
                    $(this).find('ul li').each(function (index) {
                        if ($(this).html().indexOf(adress) > 0) {
                            $(this).addClass('activeMenu');
                        }
                    });
                }

                first = null;
                return;
            } else if ($(this).html().indexOf(first) > 0) {
                $(this).addClass('activeMenu');
            }
        });
    }
    /* next level menu */
    $('.dropdown-submenu a.test').on("click", function (e) {
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
    });

    $(window).on('scroll', function () {
        var st = $(window).scrollTop();
        if (st > 100) {
            $('.scrollTop').addClass('show');
        } else {
            $('.scrollTop').removeClass('show');
        }

    });


    $('.scrollTop').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });

});
//# sourceMappingURL=default.js.map

// allow show multi level menu
$('.dropdown-submenu a.test').click(function (event) {
    event.stopImmediatePropagation();
})
$('.dropdown-submenu .dropdown-submenu a.dropdown-toggle').click(function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    $(this).toggleClass('hover');
})

//Przesuwane menu

$('.nav_btn').click(function () {
    $(this).toggleClass('hidden');
    $('.sidebar').toggleClass('toLeft');
    $('body').toggleClass('toLeft');
    $('.blur').toggleClass('hidden');
});

$('.nav_btn--close').click(function () {
    $('.nav_btn').toggleClass('hidden');
});


//zmiana styli na wcag
function setcolorimg() {
    $('.sprite.contrast').removeClass('active');

}

function setbwimg() {
    $('.sprite.contrast').addClass('active');


}

//get style cookie
$_COOKIE = {};
eval((document.cookie + ';').replace(/([\w%]+)=?([^;]*);/g, "$$_COOKIE['$1']='$2';"));
if ($_COOKIE.mysheet == 'mono') {
    $('.access').addClass('wcag');
    setbwimg();
} else {
    setcolorimg();
}

$('.access').click(function (event) {
    event.preventDefault();
});

function setStyleNone() {
    chooseStyle('none', 60);
}

function setStyleMono() {
    chooseStyle('mono', 60);
}


$('.access').click(function () {
    if ($(this).hasClass('wcag')) {
        chooseStyle('none', 60);
        $(this).removeClass('wcag');
        setcolorimg();

    } else {
        chooseStyle('mono', 60);
        $(this).addClass('wcag');
        setbwimg();

    }
});

$(document).ready(function () {
    var adress = window.location.pathname;
    if (adress == '/mapa-strony') {
        $('.sprite.maps').addClass('active');
    }
    if (adress == '/aktualnosci') {
        $(".test").first().addClass('activeMenu');
    }

});

$(document).ready(function () {
    var url = window.location.pathname.split("/");
    var partOne = url[1] + "/";
    var partTwo = url[2];
    if (partOne == "aktualnosci/") {
        $(".test").first().addClass('activeMenu');
    }

    $('.activeMenu').closest('ul').show();

});


$(document).ready(function () {
    $('.sitemap > .dropdown-submenu').removeClass('dropdown-submenu');
    $('.sitemap > li > .dropdown-toggle').removeClass('dropdown-toggle');
    $('.sitemap > li > .dropdown-menu').removeClass('dropdown-menu');
    $('.sitemap  .dropdown-menu').removeClass('dropdown-menu');
});

//Wyszukiwarka 
$(document).ready(function () {
    $('.sprite.search').click(function () {
        $('.search_block-xs').slideToggle('slow');
    });
});

$(document).ready(function () {
    $('.close-search').click(function () {
        $('.search_block-xs').slideUp('slow');
    });
});

$("p,h1,h2,h3,h4,h5,span,.header__text,.carousel-caption").each(function () {
    var tekst = $(this).html();
    tekst = tekst.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;"); //jednoznakowe
    tekst = tekst.replace(/(\s)([^<][\S]{1})[\s]+/g, "$1$2&nbsp;"); //dwuznakowe
    $(this).html(tekst);
});

/*
//focus menu wcag
$(document).ready(function(){

$('.dropdown-toggle').focus(function(){
$(this).parent().addClass('open-menu');
});

$('.dropdown-toggle').click(function(){
$(this).parent().removeClass('open-menu');
});
    
$('.dropdown-menu li:last-child a').focusout(function(){
$('.dropdown-submenu').removeClass('open-menu');
});




});
*/


